export default "/compounding.73564f2fc705449d9fc333dd2ab1f9a2.svg";